"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Flex = _interopRequireDefault(require("./Flex.js"));
var _Link = _interopRequireDefault(require("./Link.js"));
var _Loader = _interopRequireDefault(require("./Loader.js"));
var _String = _interopRequireDefault(require("./String.js"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Component simplifying the rendering of loading/error/retry states
 * 
 * Original author @heron-web/material (no longer maintained)
 */const Loadable = props => {
  /**
   * Render the error state.
   *
   * @return {ReactNode}
   */
  const renderError = () => {
    return renderOwnContent(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
        color: "error",
        gap: props.gap,
        str: props.errorStr,
        ...props.ErrorStringProps
      }), props.onRetry && renderErrorRetry()]
    }));
  };

  /**
   * Render the error retry link.
   *
   * @return {ReactNode}
   */
  const renderErrorRetry = () => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
      label: props.retryLabel,
      onClick: props.onRetry,
      ...props.ErrorRetryLinkProps
    });
  };

  /**
   * Render the loader.
   *
   * @return {ReactNode}
   */
  const renderLoader = () => {
    return renderOwnContent(/*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
      size: props.loaderSize,
      ...props.LoaderProps
    }));
  };

  /**
   * Render a node as our own child, as opposed to parent's content.
   *
   * (E.g. loading/error states.)
   *
   * @param {ReactNode} children
   * @return {ReactNode}
   */
  const renderOwnContent = children => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
      alignItems: "center",
      gap: props.gap,
      ...props.FlexProps,
      children: children
    });
  };
  if (props.loading) return renderLoader();else if (props.error) return renderError();else return props.children;
};
Loadable.propTypes = {
  FlexProps: _propTypes.default.object,
  ErrorStringProps: _propTypes.default.object,
  ErrorRetryLinkProps: _propTypes.default.object,
  LoaderProps: _propTypes.default.object,
  children: _propTypes.default.node,
  error: _propTypes.default.bool,
  errorStr: _propTypes.default.string,
  gap: _propTypes.default.number,
  loading: _propTypes.default.bool,
  loaderSize: _propTypes.default.number,
  onRetry: _propTypes.default.func,
  retryLabel: _propTypes.default.string
};
Loadable.defaultProps = {
  error: false,
  errorStr: "Error.",
  gap: 0.5,
  loading: false,
  loaderSize: 25,
  retryLabel: "Retry"
};
var _default = exports.default = Loadable;